import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl;
  autostyleUrl = environment.autostyleUrl

  // private baseUrl2 = 'https://uatnvteassistanceservice.icodex.in/support/output/';
  // private baseUrl2 = 'http://nvteassistanceservice.icodex.in/support/output/';

  // deleteJobFolder(jobId: string) {
  //   throw new Error('Method not implemented.');
  // }
  getdata() {
    throw new Error('Method not implemented.');
  }

  deleteJobFolder(jobId: string, Key: string) {
    debugger
    let headers = new HttpHeaders({
      'OutSetXApi': Key,

    });

    let url = `${environment.apiUrlucc}${jobId}`;

    return this.http.get(url, { headers });
  }

  deletepreJobFolder(jobId: string, Key: string) {
    debugger
    let headers = new HttpHeaders({
      'OutSetXApi': Key,

    });

    let url = `${environment.apipredelete}${jobId}`;

    return this.http.get(url, { headers });
  }



  uploadFile(file: File, jobid: string, apikey: string): Observable<any> {
    let headers = new HttpHeaders({
      'eAssistantXApiKey': apikey,

    });

    let formData = new FormData();
    formData.append('InputFile', file);


    let Url = `${environment.apiUrl2}${jobid}`;

    return this.http.post(Url, formData, { headers });
  }

  uploadFilepreEditing(file: File, jobid: string, apikey: string): Observable<any> {
    let headers = new HttpHeaders({
      'OutSetXApi': apikey

    });

    let formData = new FormData();
    formData.append('InputFile', file);


    let Url = `${environment.apiUrl3}${jobid}`;

    return this.http.post(Url, formData, { headers });
  }

    getUccOutput(jobId: string, key: string): Observable<HttpResponse<Blob>> {
    let url = `${environment.apiuccoutput}${jobId}`;
    const headers = new HttpHeaders({
        'eAssistantXApiKey': key
      });

    return this.http.get(url, {
      headers,
      responseType: 'blob',
      observe: 'response' 
    });
  }

  getPreEditingOutput(jobId: string, key: string): Observable<HttpResponse<Blob>> {
    debugger
    const headers = new HttpHeaders({
      'OutSetXApiKey': key
    });

    const url = `${environment.apiUrl4}${jobId}?Inputfile=`;

    return this.http.get(url, { headers, responseType: 'blob', observe: 'response'  });
  }

  // private apiUrl = 'https://qanetrapi.icodex.in/';
  getRemoteData(): Observable<any[]> {
    debugger
    return this.http.get<any[]>(this.baseUrl);
  }

  public uploadInput(file: File, apiKey: string, referenceNumber: any, uploadType: any): Observable<any> {
    debugger
    const headers = new HttpHeaders({
      'eProofingXApiKey': apiKey,
      'ReferenceNumber': referenceNumber,      
    });

    const formData = new FormData();

    if (uploadType === 'cv') {
      formData.append('file', file);
    } else {
      alert('JatsInputFile')
      formData.append('JatsInputFile', file);
    }

    // Set correct URL based on type
    const url = uploadType === 'cv'
      ? `${environment.apiUrl}/input/upload`
      : `${environment.apiUrl}/JatsInput`;

    console.log("POST", url, file, { headers });

    return this.http.post(url, formData, { headers });
  }

  public getTabledata(): Observable<any> {
    let baseUrl = environment.baseUrl;
    let url = `${baseUrl}api/Values/getall`;
    return this.http.get(url);
  }

  public getrowdata(ArticleId: any): Observable<any> {
    let baseUrl = environment.baseUrl;
    let url = `${baseUrl}api/Values/getallarticaldata?articleId=${ArticleId}`;
    return this.http.get(url);
  }

  public searchdata(requestBody: any): Observable<any> {
    let url = `${this.baseUrl}api/Values/postRaisedBy`;
    return this.http.post(url, requestBody);
  }

  public getIssues(): Observable<any> {
    debugger
    let url = `${this.baseUrl}api/Values/getIsshu`;
    return this.http.get<any>(url);
  }

  public getInputdetail(inputFileValue: any): Observable<any> {
    debugger
    let url = `${this.baseUrl}api/Values/searchArticalId?articleId=${inputFileValue}`;
    return this.http.get<any>(url);
  }

  public getRefNoId(RefNoValue: any): Observable<any> {
    debugger
    let url = `${this.baseUrl}api/Values/searchReferenceNo?refNo=${RefNoValue}`;
    return this.http.get<any>(url);
  }

  public getDateDetail(fromDate: string, toDate: string): Observable<any> {
    let params = new HttpParams()
      .set('fromDate', fromDate)
      .set('toDate', toDate);

    let url = `${this.baseUrl}api/Values/GetByDate`;

    return this.http.get<any>(url, { params });
  }

  public getCeTeData(): Observable<any> {
    let url = `${this.baseUrl}api/CETE/CETEMethodget`;
    return this.http.get<any>(url);
  }

  public getCeTejournal(): Observable<any> {
    debugger
    let url = `${this.baseUrl}api/CETE/JournalLookUp`;
    return this.http.get<any>(url);
  }

  public postData(requestBody: any): Observable<string> {
    let url = `${this.baseUrl}api/CETE/mapingjorunalwithmethods`;
    return this.http.post(url, requestBody, { responseType: 'text' });
  }

  public getmethodId(selectedId: any): Observable<any> {
    let url = `${this.baseUrl}api/CETE/getMethodsByJId?id=${selectedId}`;
    return this.http.get<any>(url);
  }

  public journalMapping(requestBody: any): Observable<any> {
    let url = `${this.baseUrl}api/CETE/updatejournalmapping`;
    return this.http.post(url, requestBody, { responseType: 'text' })
  }

  public journalData(requestBody: any): Observable<any> {
    let url = `${this.baseUrl}api/CETE/insertNewJournalInLookUp`;
    return this.http.post(url, requestBody, { responseType: 'text' })
  }


  public getdefaultlookup(): Observable<any> {
    let url = `${this.baseUrl}api/CETE/getDefaultMethodLookup`;
    return this.http.get<any>(url)
  }

  public getDownload(key: string): Observable<HttpResponse<Blob>> {
    debugger
    const url = `${this.baseUrl}api/DownloadHtmlPR1/download-file`;
    const params = new HttpParams().set('key', key);

    return this.http.get(url, {
      params,
      observe: 'response',
      responseType: 'blob'
    });
  }

  public getUCCDownload(uccText: string): Observable<HttpResponse<Blob>> {
    let url = `${this.baseUrl}api/DownloadFromAWSA/download-file`;
    let params = new HttpParams().set('key', uccText);

    return this.http.get(url, {
      params,
      observe: 'response',
      responseType: 'blob'
    });
  }

  public getMultipleFile(folderPath: string): Observable<any> {
    const url = `${this.baseUrl}api/DownloadHtmlPR1/list-files`;
    const params = new HttpParams().set('folderPath', folderPath);

    return this.http.get(url, { params });
  }

  public getMultipleUccFile(folderPath:string): Observable <any> {
    let url = `${this.baseUrl}api/DownloadFromAWSA/list-files`;
    const params = new HttpParams().set('folderPath', folderPath);

    return this.http.get(url, {params});
  }

  public downloadFile(key: string): Observable<Blob> {
    const url = `${this.baseUrl}api/DownloadHtmlPR1/download-file`;
    const params = new HttpParams().set('key', key);

    return this.http.get(url, {
      params,
      responseType: 'blob' as 'blob'
    });
  }


  public DownloadFile(referenceNumber: string): Observable<any> {
    const url = `${this.autostyleUrl}/support/download/${referenceNumber}?Inputfile=`;

    const headers = new HttpHeaders({
      'OutSetXApiKey': 'CQSmbs3TVopW'
    });

    return this.http.get(url, {
      headers,
      responseType: 'blob'
    });
  }

  public getLogindetail(username: string, password: string): Observable<any> {
    debugger
    let url = `${this.baseUrl}api/Values/login`;
    const params = new HttpParams()
      .set('username', username)
      .set('password', password);
    return this.http.post<any>(url, null, { params });
  }

  public getArticleCount(): Observable<any> {
    let url = `${this.baseUrl}api/Values/total-article-count`;
    return this.http.get(url)
  }

}
